import { Badge } from "./ui/badge";
import type { AccountInfo } from "../lib/types";

interface UsageBadgeProps {
  account: AccountInfo;
}

export function UsageBadge({ account }: UsageBadgeProps) {
  const dialogPercent =
    account.dialogsLimit > 0
      ? Math.round((account.dialogsUsed / account.dialogsLimit) * 100)
      : 0;
  const isWarning = dialogPercent >= 80;
  const isCritical = dialogPercent >= 95;

  return (
    <div className="flex items-center gap-2">
      <Badge variant="outline">{account.plan}</Badge>
      <Badge variant={isCritical ? "destructive" : isWarning ? "secondary" : "outline"}>
        {account.funnelsUsed}/{account.funnelsLimit} воронок
      </Badge>
      <Badge variant={isCritical ? "destructive" : isWarning ? "secondary" : "outline"}>
        {account.dialogsUsed}/{account.dialogsLimit} диалогов
      </Badge>
    </div>
  );
}
